import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import InlineDataField from 'Components/ComponentLibrary/Molecules/InlineDataField';
import { fullDate } from 'Consts/DateFormats';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ManagedAccountPageInfoBarLayout from './ManagedAccountPageInfoBarLayout';
import ManagedAccountPageInfoStat, {
  ManagedAccountPageContributionStat,
  ManagedAccountPageAccountNumberStat,
} from './ManagedAccountPageInfoStat';


const useStyles = buildUseStyles('ManagedAccountActivityInfo', () => ({
  metaFormInline: {
    padding: 0,
    backgroundColor: 'inherit',
  },
}));

const metaOverrideSet = fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
  })
  .nameOverride('balance', {
    _component: () => Text,
    _customProps: {
      variant: 'h2',
      weight: 'bold',
      test: 'managed-account-balance',
    },
  }, { ordinal: 201 })
  .nameOverride('lastUpdated', {
    _component: () => InlineDataField,
    _customProps: {
      test: 'managed-account-last-updated',
    },
    _formatString: fullDate,
  }, { ordinal: 201 })
  .nameOverride('currentYearContributionTotal', {
    _component: () => ManagedAccountPageContributionStat,
  }, { ordinal: 201 })
  .nameOverride('previousYearContributionTotal', {
    _component: () => ManagedAccountPageContributionStat,
  }, { ordinal: 201 })
  .nameOverride('accountOwner', {
    _component: () => ManagedAccountPageInfoStat,
  }, { ordinal: 201 })
  .nameOverride('accountNumber', {
    _component: () => ManagedAccountPageAccountNumberStat,
  }, { ordinal: 201 })
  .nameOverride('apy', {
    _component: () => ManagedAccountPageInfoStat,
  }, { ordinal: 201 })
  .nameOverride('allocationModelName', {
    _component: () => ManagedAccountPageInfoStat,
  }, { ordinal: 201 })
  .nameOverride('primaryOwnerRiskTolerance', {
    _component: () => ManagedAccountPageInfoStat,
  }, { ordinal: 201 });

export default function ManagedAccountPageInfoBar({ resource }) {
  const classes = useStyles();

  return (
    <MetaFormInline
      className={classes.metaFormInline}
      noIndividualSubmitButtons
      resource={resource}
      layout={ManagedAccountPageInfoBarLayout}
      metaOverrideSet={metaOverrideSet}
    />
  );
}
ManagedAccountPageInfoBar.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
